import type { File } from '@webapp/account/src/resources/filemanager/file';

export interface FileManagerState {
    files: Array<File>;
    fetch: boolean;
    loaded: boolean;
    error: string | null;
    uploadFetch: boolean;
    uploadProgress: number;
}

export const initialState: Readonly<FileManagerState> = {
    files: [],
    fetch: false,
    loaded: false,
    error: null,
    uploadFetch: false,
    uploadProgress: 0,
};
